import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services';

export const isAuthenticatedGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(AuthenticationService).isAuthenticated()
    ? true
    : inject(Router).createUrlTree(['authentication/login']);
};

export const isNotAuthenticatedGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return !inject(AuthenticationService).isAuthenticated()
    ? true
    : inject(Router).createUrlTree(['home']);
};
